import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, Paper, Tabs, Tab } from '@mui/material';

function DeviceDetail() {
  const { deviceId } = useParams();
  const [tabValue, setTabValue] = React.useState(0);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>Device Details</Typography>
      <Paper sx={{ mb: 2 }}>
        <Tabs value={tabValue} onChange={(e, v) => setTabValue(v)}>
          <Tab label="Overview" />
          <Tab label="Location" />
          <Tab label="Camera" />
          <Tab label="Audio" />
          <Tab label="Activity" />
        </Tabs>
      </Paper>
      <Paper sx={{ p: 3 }}>
        <Typography>Device ID: {deviceId}</Typography>
        <Typography color="textSecondary">Detailed view coming soon...</Typography>
      </Paper>
    </Box>
  );
}

export default DeviceDetail;
